export const LANDING = '/';

export const HOME = '/home';
export const ABOUT = '/about';
export const SERVICES = '/services';
export const CONTACT = '/contact';


